<!-- Backdrop -->
<div class="side-panel-backdrop"
     [class.side-panel-backdrop--visible]="panel.isOpen()"
     (click)="panel.triggerCancel()">
</div>

<!-- Panel -->
<div class="side-panel"
     [class.side-panel--open]="panel.isOpen()">

  @if (panel.config(); as config) {

    <!-- Header: mostra sempre il layer in cima allo stack -->
    <div class="shrink-0 flex items-center gap-2 px-4 pt-2 border-b border-base-200 bg-base-100">
      <h4 class="text-sm font-semibold shrink-0">
        {{ config.titleKey | translate }}
      </h4>
      <span class="text-sm font-medium text-primary flex-1 truncate" data-testid="side-panel-entity-name">
        {{ panel.headerSubtitle() }}
      </span>
      @if (panel.headerToggle(); as toggle) {
      <label class="flex items-center gap-2 cursor-pointer shrink-0">
        <span class="text-xs font-medium">{{ toggle.labelKey | translate }}</span>
        <input type="checkbox" class="toggle toggle-primary toggle-xs" [checked]="toggle.checked"
               data-testid="side-panel-edit-toggle"
               (change)="panel.requestHeaderToggle($any($event.target).checked)" />
      </label>
      }
      <button class="btn btn-ghost btn-xs btn-square" data-testid="side-panel-close-btn" (click)="panel.triggerCancel()">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
             viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Content: tutti i layer dello stack; solo il top è visibile, gli altri
         restano montati con [hidden] così il loro stato viene preservato. -->
    <div class="flex-1 min-h-0 overflow-hidden">
      @for (entry of panel.stack(); track entry.token) {
        <div [hidden]="entry.token !== panel.topToken()" class="h-full">
          <ng-container [ngComponentOutlet]="entry.config.component"
                        [ngComponentOutletInputs]="allInputs().get(entry.token)">
          </ng-container>
        </div>
      }
    </div>

    <!-- Footer: canSave/isSaving/mode riflettono il layer in cima -->
    <div class="shrink-0 flex items-center justify-end gap-2 px-4 py-3 border-t border-base-200 bg-base-100">
      <button type="button" class="btn btn-sm btn-ghost" data-testid="side-panel-cancel-btn" (click)="panel.triggerCancel()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-sm btn-outline btn-primary"
              data-testid="side-panel-save-btn"
              [disabled]="!panel.canSave() || panel.isSaving()"
              (click)="panel.triggerSaveWithoutClose()">
        @if (panel.isSaving()) {
          <span class="loading loading-spinner loading-xs"></span>
        }
        {{ (panel.isNewEntity() ? 'COMMON.CREATE' : 'COMMON.UPDATE') | translate }}
      </button>
      <button type="button" class="btn btn-sm btn-primary"
              data-testid="side-panel-save-close-btn"
              [disabled]="!panel.canSave() || panel.isSaving()"
              (click)="panel.triggerSave()">
        @if (panel.isSaving()) {
          <span class="loading loading-spinner loading-xs"></span>
        }
        {{ (panel.isNewEntity() ? 'COMMON.CREATE_AND_CLOSE' : 'COMMON.UPDATE_AND_CLOSE') | translate }}
      </button>
    </div>

  }

</div>
